<template>
    <div class="message-page">
        <mt-header fixed title="消息中心" style="background:#ffffff;color:#262626;">
            <mt-button icon="back" slot="left" @click="goBack"></mt-button>
        </mt-header>

        <div class="scroll-wrapper">
            <div class="scroll-content">
                <div class="no-data" v-if="messageList.length==0">
                    <img src="../assets/images/message_data_none@3x.png">
                    <p>暂无消息通知</p>
                    <div class="goBack" @click="goBack">返回</div>
                </div>

                <ul class="message-list" v-if="messageList.length>0"
                    v-infinite-scroll="getMessages"
                    infinite-scroll-disabled="loading"
                    infinite-scroll-immediate-check = true
                    infinite-scroll-distance="3">
                    <li v-for="(item,index) in messageList" :key="index">
                        <img src="../assets/images/message_icon@3x.png">
                        <div class="content">
                            <div class="title">
                                <span>系统消息</span>
                                <span>{{item.created_at | timeFormat}}</span>
                            </div>
                            <div class="text">{{item.subject}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
import { InfiniteScroll } from 'mint-ui';

export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            isAgreed: true,
            isShow: false,
            isTransparent: false,
            redirect_uri: "https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101852472&state=my&display=mobile&redirect_uri="+window.config.redirect_uri+"/bandMobile",
            nextPath: '',
            messageList: []
        }
    },
    mounted(){
    },
    created(){
        localStorage.removeItem('msg_last_id')
        this.nextPath = this.$route.query.path
        this.getMessages()
    },
    methods:{
        goBack(){
            history.go(-1)
        },
        getMessages(){
            let vm = this
            let access_token = localStorage.access_token
            let msg_last_id = localStorage.msg_last_id
            let data = {
                access_token: access_token,
                info: {
                    app_id: window.config.appid
                }
            }
            if(msg_last_id != 'null'){
                data.info['last_id'] = msg_last_id
            }
            this.$store.dispatch('getMessages',data).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.messageList = this.messageList.concat(result.res)
                    if(this.messageList.length>0){
                        let len = this.messageList.length
                        localStorage.msg_last_id = this.messageList[len-1].id
                    }
                }
            })
        }
    },
    components:{
        InfiniteScroll
    },
    filters:{
        timeFormat(val){
            return new moment(val).format('MM-DD hh:mm')
        }
    },
    destroyed(){
        
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Message.vue